import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import FontKeys from '../FontKeys';

export default class LevelSelectButton extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {{destinationId: string, map: string, bestTime: number, medal: string, baseType: string, levelId: number}} btnData
   */
  constructor(scene,btnData) {
    super(scene);

    this.btnId = btnData.levelId;

    this.bg = ABCyaPhaser.Images.addImage(0,0,'btn-level-bg', this);
    const stringKey = btnData.destinationId.toLocaleLowerCase().replace(' ', '_');
    const localizedString = ABCyaPhaser.Localization.instance.getLocalizedString(`level_select.${stringKey}`); // This is used to localize the text, but maintain frame name for image

    this.btnLbl = ABCyaPhaser.Text.addText(0, 0, 29, gameData.gameConfigs[gameData.game].BTN_TXT_COLOR, FontKeys._cloudy_with_a_chance_of_lovRg, localizedString, this, true).setOrigin(0.5)
      .setWordWrapWidth(215);
    ABCyaPhaser.Text.resizeFontToFitWidth(this.btnLbl, 215);

    this.coinHolder = ABCyaPhaser.Images.addImage(-this.bg.width / 2, -this.bg.height / 2, 'coin-holder', this);

    const levelText = ABCyaPhaser.Localization.instance.getLocalizedString('level_select.level') ?? 'Level';

    this.levelTxt = ABCyaPhaser.Text.addText(this.coinHolder.x + this.coinHolder.width / 2 + 10, 0, `${16}pt`, 0x595260, FontKeys._cloudy_with_a_chance_of_lovRg, `${levelText} ${btnData.levelId}`, this, false).setOrigin(0);
    this.levelTxt.y = (-this.bg.height / 2) - this.levelTxt.height;

    const timeStr = this.formatTimeString(btnData.bestTime);
    this.timeTxt = ABCyaPhaser.Text.addText(0,this.levelTxt.y, `${16}pt`, 0x595260, FontKeys._cloudy_with_a_chance_of_lovRg, timeStr, this).setOrigin(0);
    this.timeTxt.x = (this.bg.width / 2) - this.timeTxt.width;

    this.bringToTop(this.coinHolder);

    if (btnData.medal !== '') {
      this.coin = ABCyaPhaser.Images.addImage(this.coinHolder.x, this.coinHolder.y, `coin-${btnData.medal}`, this);
    }

    ABCyaPhaser.Container.setContainerInteractive(this, false);
  }

  formatTimeString (timeInMilliseconds) {
    const seconds = Math.floor(timeInMilliseconds / 1000);
    const minutes = Math.floor(seconds / 60);

    let minutesStr = minutes.toString();
    if (minutesStr.length < 2) minutesStr = `0${minutesStr}`;

    let secondsStr = seconds.toString();
    if (secondsStr.length < 2) secondsStr = `0${secondsStr}`;

    let milliStr = (timeInMilliseconds - (seconds * 1000)).toString();
    if (milliStr.length < 2) milliStr = `0${milliStr}`;

    if (milliStr.length > 2) milliStr = milliStr.substring(0,2);

    return `${minutesStr}:${secondsStr}.${milliStr}`;
  }
}